export const css = {
    leading: '_1UIuvSCQ',
    trailing: '_2UfGkdYL',
    ' _key': 'afcpe-theme/dojo/three-column-layout'
};
export default css;
